// AutoSaveIndicator - Indicador de guardado automático y estado online/offline
// Sprint 3

import React from 'react';
import { Box, Chip, CircularProgress } from '@mui/material';
import {
  CloudDone as CloudDoneIcon,
  CloudOff as CloudOffIcon,
  Save as SaveIcon,
} from '@mui/icons-material';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';

interface AutoSaveIndicatorProps {
  saving: boolean;
  lastSaved: Date | null;
  isOnline: boolean;
}

const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({
  saving,
  lastSaved,
  isOnline,
}) => {
  const getLabel = () => {
    if (saving) return 'Guardando...';
    if (!isOnline) return 'Modo offline';
    if (lastSaved) {
      return `Guardado ${formatDistanceToNow(lastSaved, { 
        addSuffix: true,
        locale: es,
      })}`;
    }
    return 'Sin cambios';
  };

  const getIcon = () => {
    if (saving) return <CircularProgress size={16} color="inherit" />;
    if (!isOnline) return <CloudOffIcon />;
    if (lastSaved) return <CloudDoneIcon />;
    return <SaveIcon />;
  };

  const getColor = () => {
    if (saving) return 'info';
    if (!isOnline) return 'warning';
    if (lastSaved) return 'success';
    return 'default';
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 16, sm: 24 },
        right: { xs: 16, sm: 24 },
        zIndex: 1000,
      }}
    >
      <Chip
        icon={getIcon()}
        label={getLabel()}
        color={getColor() as any}
        size="small"
        sx={{
          fontSize: '0.75rem',
          fontWeight: 500,
          boxShadow: 2,
        }}
      />
    </Box>
  );
};

export default AutoSaveIndicator;
